import React from "react";
import styled from "styled-components";

export default function CalculationFomulaModal(props) {
  const { 
    isView,
    denominator,
    denominatorText,
    numerator,
    numeratorText,
    result,
    resultUnit,
    innerBoxBackgroundColor,
    componentBoxBackgroundColor
  } = props;

  return (
    <TopLevelWrapper isView={isView}>
      <Triangle backgroundColor={componentBoxBackgroundColor}/>
      <ComponentBox backgroundColor={componentBoxBackgroundColor}>
        <CalcInfoBox backgroundColor={innerBoxBackgroundColor}>
          <ColumnWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='default'>{denominator}</Text>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>{denominatorText}</Text>
          </ColumnWrapper>
          <DivisionLine />
          <ColumnWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='default'>{numerator}</Text>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>{numeratorText}</Text>
          </ColumnWrapper>
        </CalcInfoBox>
        <Text fontFamily='NotoSansKR-Medium' fontSize={20} color='#FFFFFF' cursor='default'>X</Text>
        <Text style={{ marginTop: '-4px' }} fontFamily='NotoSansKR-Bold' fontSize={30} color='#FFFFFF' cursor='default'>100</Text>
        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='default'>=</Text>
        <ResultWrapper>
          <Text style={{ marginTop: '-4px' }} fontFamily='NotoSansKR-Bold' fontSize={30} color='#FFFFFF' cursor='default'>{result}</Text>
          <Text style={{ marginTop: '12px' }} fontFamily='NotoSansKR-Bold' fontSize={10} color='#FFFFFF' cursor='default'>{resultUnit}</Text>
        </ResultWrapper>
      </ComponentBox>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 170px;
  margin-left: 54px;

  opacity: ${props => props.isView ? 1 : 0};
  pointer-events: ${props => props.isView ? 'auto' : 'none'};

  transition: all 0.3s ease-in-out;
`;

const Triangle = styled.div`
  margin-left: 10px;

  width: 0;
  height: 0;

  border-bottom: 7px solid ${props => props.backgroundColor};
  border-right: 11px solid transparent; 
`;

const ComponentBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 10px;

  gap: 6px;

  border-radius: 10px;
  background-color: ${props => props.backgroundColor};
`;

const CalcInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px;

  border-radius: 10px;
  background-color: ${props => props.backgroundColor};
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const DivisionLine = styled.div`
  margin: 2px 0px;

  width: 100%;
  height: 1px;

  border-radius: 2px;
  background-color: #FFFFFF;
`;

const ResultWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 2px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;